
const WORDS_WITH_SQUARE_BRACKETS = /\[(.*?)\]/g;

export {WORDS_WITH_SQUARE_BRACKETS}